// eslint-disable-next-line @typescript-eslint/no-explicit-any
export async function retryWithDelay(
  fn: () => Promise<void> | undefined,
  onError: (error: Error) => void,
  retryCount: number,
  delayBasis = 1000,
) {
  for (let i = 0; i < retryCount; i++) {
    try {
      const result = await fn();

      return result;
    } catch (error) {
      onError(error);

      await new Promise(resolve => setTimeout(resolve, (i + 1) * delayBasis));
    }
  }

  throw new Error('Исчерпано количество попыток повтора');
}
